import { Col, Row } from "react-bootstrap";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import { images } from "../../../../constants";
import { FriendsChat } from "../../../../constants/jsonConstant";


import "./Chatbox.css";
const Chatbox = ({ setChatmodal,setChatsubbox}) => {
  const friendChatOpen=()=>{
    setChatsubbox(true)
    setChatmodal(false)
  }
  return (
   
    <>
      <Col lg="8" md="5" sm="9" className="chatBoxUsers mt-2 p-3">
        <div className="background-white  border p-3">
          <Row>
            <Col lg="6" md="6" sm="6" xs="6" className="d-flex">
              <img src={images.Profileimg} alt="" className="chatboxImg2" />
              <h5 className="mt-1">&nbsp;&nbsp;Chat</h5>
            </Col>
            <Col lg="6" md="6" sm="6" xs="6" className="d-flex justify-content-end">
              {/* <MoreHorizOutlinedIcon /> */}
              {/* <CreateOutlinedIcon /> */}
              <ArrowDropDownOutlinedIcon onClick={() => setChatmodal(false)} />
            </Col>
          </Row>
          <div className="chatBorderLine">
            <input placeholder="Search" className="search-input1 mt-1"/>
            </div>
          <div className="chatFriendScroll mt-3 noscroll">
            {FriendsChat?.map((friends) => (
              <Row
                key={friends.id}
                // onClick={() => boxOpenHandler(3)}
              >
                <Col lg="2" md="2" sm="2" xs="2">
                  <img src={friends.friendImg} alt="" className="chatboxImg2" />
                </Col>

                <Col lg="10" md="10" sm="10" xs="10" onClick={()=>friendChatOpen()}>
                  <h5 className="font_small">{friends.friendName}</h5>
                  <p className="font_small">{friends.friendDescription}</p>
                </Col>

                <div className="chatBorderLine"></div>
              </Row>
            ))}
          </div>
        </div>
     
      </Col>
   
    </>
  );
};

export default Chatbox;
